import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { LoyaltyLotKind } from './Enums'
/**
* Class ShowcaseLoyaltyActiveLotDto
*  Активный лот кошелька.
*/
export class ShowcaseLoyaltyActiveLotDto extends ActiveModel {

  /**
  * id
  *   */
  @ActiveField(0)
  id: number = 0


  /**
  * kind
  * словарь значений публикуется под именем `Domain.Entities.Loyalty.LoyaltyLotKind`  *   * Тип bonus-лота (кэшбэк или промо).  *   * - `Cashback` Кэшбэк  * - `Promo` Промо  *   */
  @ActiveField(LoyaltyLotKind.CASHBACK)
  kind: LoyaltyLotKind = LoyaltyLotKind.CASHBACK


  /**
  * remaining
  *   */
  @ActiveField(0)
  remaining: number = 0


/**
  * expiresAt
  * 
  */
  @ActiveField()
  expiresAt?: null | string
}
